var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.wordViews).length > 0)?_c('BarChart',{staticClass:"chart-container",attrs:{"chartdata":_vm.chartDataWordViews(),"options":_vm.wordviewOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }